import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {ModelProvider} from "../../../../../framework/providers/modelProvider/ModelProvider";
import {Events} from "../../../../../framework/providers/events";
import {IonSlides, ModalController} from "@ionic/angular";
import {ItemProperty} from "../../../../../framework/model/core/items/itemProperty";
import {AppDataService} from "../../../../services/AppDataService";
import {ItemProvider} from "../../providers/item-provider/item-provider.service";
import {ModelToolsProvider} from "../../../../../framework/providers/model-tools/model-tools";

@Component({
    selector: 'app-filter-res-page',
    templateUrl: './filter-res-page.component.html',
    styleUrls: ['./filter-res-page.component.scss'],
})
export class FilterResPageComponent implements OnInit {

    @Input()
    public filters;

    public wizard_filters;
    public sub_filters;

    @Input()
    public currentListFilters;
    public subItemFilters = {};

    @Input()
    public prefix = this.tools.getRandomize();

    public checked = {}
    public options = {'amount':0}
    public items = []
    public subitems = []

    @ViewChild('slider') slider: IonSlides;

    constructor(public modelProvider: ModelProvider, public appevents: Events, public modalController: ModalController,
                public tools:ModelToolsProvider,
                public appDataService:AppDataService, public itemProvider:ItemProvider) {
    }

    ngOnInit() {
        if(!this.filters){
            this.initFilters()
            return
        }
        this.initWizard()
    }

    initFilters()
    {
        this.currentListFilters['setPrefix'] = true;
        this.modelProvider.custom('getItemsFilters', this.currentListFilters).then((res) => {
            this.filters = res['res']
            // this.filters = []
            // this.getSubFilter();

            this.initWizard();
        })
    }

    initSubFilters()
    {
        let subfilters = JSON.parse(JSON.stringify(this.currentListFilters))
        subfilters['extSectionId'] = subfilters['sectionId']+'_sub'
        subfilters['checked_props'] = this.subItemFilters['checked_props'] ? this.subItemFilters['checked_props'] : {}
        subfilters['include_rest_props'] = true
        subfilters['only_subs'] = true
        delete subfilters['sectionId']
        this.subItemFilters = subfilters
        // this.subfilter_changed(false);
    }

    getSubFilter()
    {
        this.initSubFilters();

        this.modelProvider.custom('getItemsFilters', this.subItemFilters).then((res) => {
            this.sub_filters = res['res'];
            // this.initSubFilters();
        })
    }

    subfilter_changed(refresh=true)
    {
        let res = this.getActiveProdata();
        let checked = this.subItemFilters['checked_props'];
        let types = this.sub_filters;
        if(!types) return
        for (let type of types) {
            let value = checked[type['code']] ? 'כן': 'לא';
            // if (!checked[type['code']]) continue
            res.push(type['code'] + ',' + value)
        }

        let prodata = res.join('|')
        // console.log(prodata)
        this.subItemFilters['prodata'] = prodata

        if(refresh)
        {
            this.modelProvider.custom('getItemsByFilters', this.subItemFilters).then((res) => {
                this.subitems = res['items'];
                this.appevents.publish(this.prefix + '_resSubFilters' + '_updateItems', {'itemsarr': this.subitems})
            })
        }
    }

    initWizard(){
        this.wizard_filters = this.filters.filter((x)=> x.is_for_wizard==true);
        this.lockSlider(true);
    }

    ngAfterViewInit() {
        this.lockSlider(true);
    }

    close() {
        this.modalController.dismiss();
    }

    swipeNext() {
        this.swip(true)
    }

    swipePrev() {
        let activeIndex = this.slider.getActiveIndex().then((activeIndex) => {
            this.getFilterByIndex(activeIndex - 1).then((filterCode)=>{
                this.setValue(filterCode, null, false)
            })
        });
    }

    swip(next = true, index = null) {
        this.lockSlider(false);

        if(index !== null) {
            this.slider.slideTo(index)
        }
        else {
            if (next) {
                this.slider.slideNext();
            } else {
                this.slider.slidePrev();
            }
        }
        this.lockSlider(true);
    }

    async getFilterByIndex(index) {
        const slides = await this.slider.getSwiper();
        const slideIdAttribute = 'data-slide-id';
        const activeSlideElement = slides.slides[index];
        const slideId = activeSlideElement.getAttribute(slideIdAttribute)
        return slideId
    }

    setValue(key, value, next = true) {
        this.checked[key] = value;
        this.getFilters(next)
    }

    lockSlider(value = true) {
        if(!this.slider) return
        this.slider.lockSwipes(value);
    }

    public currentProps = []

    getActiveProdata()
    {
        let res = []
        for (let prop in this.checked) {
            if (!this.checked[prop]) continue
            this.currentProps.push(this.checked[prop])
            res.push(prop + ',' + this.checked[prop])
        }
        return res;
    }

    getFilters(next = true) {
        console.log(this.checked)
        this.currentProps.length = 0;

        let prodata = this.getActiveProdata().join('|');

        // console.log(prodata)
        this.currentListFilters['prodata'] = prodata
        this.currentListFilters['setPrefix'] = true
        this.currentListFilters['include_rest_props'] = true
        this.currentListFilters['only_subs'] = true

        // console.log('currentListFilters:', this.currentListFilters)
        // console.log('filters:', this.wizard_filters)
        this.options['loading'] = true;
        this.modelProvider.custom('getItemsByFilters', this.currentListFilters).then((res) => {
            this.wizard_filters = res['props']
            this.items = res['items']
            let next_index = res['next_type']

            this.swip(next, next_index)

            if(!next_index){
                this.appevents.publish(this.prefix + '_resFilters' + '_updateItems', {'itemsarr': this.items})
                this.getSubFilter();
            }

            this.options['loading'] = false;
            // this.wizard_filters['itemsarr'] = res['items']
        })
    }

    setModel(prop)
    {
        prop['model'] = new ItemProperty(prop)
        console.log(prop)
    }

    addToCart(value=1, subfilter=null){
        if(subfilter)
        {
            if(!subfilter['amount']) subfilter['amount'] = 0;
            let preamount = subfilter['amount'];
            subfilter['amount'] += value

            this.getSubItems(subfilter).then((res)=>{
                this.updateAmount(preamount, subfilter, subfilter['items']);
            })
            return
        }

        let preamount = this.options.amount;
        this.options.amount += value
        this.updateAmount(preamount, this.options)
    }

    getSubItems(subfilter)
    {
        return new Promise(async (resolve, reject) => {

            if(subfilter['items'])
            {
                resolve(subfilter)
                return
            }

            let filters = JSON.parse(JSON.stringify(this.subItemFilters))
            let res = this.getActiveProdata();

            let value = 'כן'
            res.push(subfilter['code']+','+value)
            let prodata = res.join('|')
            filters['prodata'] = prodata

            this.modelProvider.custom('getItemsByFilters', filters).then((res) => {
                subfilter['items'] = res['items'];
                resolve(res);
            })
        });
    }

    updateSubFilterAmount(subfilter)
    {
        this.getSubItems(subfilter).then((res)=>{
            this.updateAmount(null, subfilter, res['items']);
        })
    }

    updateAmount(preamount = null, obj = null, itemsIds=null)
    {
        if(!obj) obj = this.options;

        if(obj.amount<0){
            obj.amount = 0
        }

        let amount = obj.amount

        if(!itemsIds) itemsIds = this.items;
        let items = this.appDataService.getItems(itemsIds, {})

        for(let item of items['res']){
            this.itemProvider.add_to_cart(item, amount, 'amount', {}, null, true)
        }
    }

}
